export default __webpack_public_path__ + "static/media/2.275c8ad6.png";